/* eslint-disable array-callback-return */
import React, { useState, useEffect, useMemo } from "react";
import ProductCard from "../ProductCard";
import {
  Button,
  Pagination,
  Menu,
  MenuItem,
  Fade,
} from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UseFetch from "../../hook/useFetch";
import { useLocation } from "react-router";
import "./style.css";

export default function SearchResults() {
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);

  // ✅ même système de tri
  const [sortBy, setSortBy] = useState("newest");

  // ✅ menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { data, loading } = UseFetch(
    "https://ebuy-backend-two.vercel.app/api/article"
  );

  // ✅ inverse pour nouveautés
  const produits = useMemo(() => {
    return Array.from(data).reverse();
  }, [data]);

  const query =
    new URLSearchParams(location.search)
      .get("query")
      ?.toLowerCase() || "";

  // ✅ menu handlers
  const handleClick = (event) => setAnchorEl(event.currentTarget);

  const handleClose = (sortValue) => {
    if (sortValue) setSortBy(sortValue);
    setAnchorEl(null);
  };

  useEffect(() => {
    const updateItemsPerPage = () => {
      const windowWidth = window.innerWidth;

      if (windowWidth >= 700) {
        setItemsPerPage(15);
      } else {
        setItemsPerPage(16);
      }
    };

    updateItemsPerPage();

    window.addEventListener("resize", updateItemsPerPage);

    return () => {
      window.removeEventListener("resize", updateItemsPerPage);
    };
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const page = parseInt(searchParams.get("page")) || 1;
    setCurrentPage(page);
  }, [location.search]);

  const filteredProducts = produits.filter((produit) => {
    const isStockVide = query === "kharroub";

    if (isStockVide) {
      return produit.stock === 0;
    }

    return (
      produit.articleName.toLowerCase().includes(query) ||
      produit.brand.toLowerCase().includes(query) ||
      produit.ref.toLowerCase().includes(query) ||
      produit.categorie.toLowerCase().includes(query) ||
      produit.famille.toLowerCase().includes(query)
    );
  });

  // ✅ tri moderne
  const sortedProducts = useMemo(() => {
    let result = [...filteredProducts];

    if (sortBy === "priceAsc") {
      result.sort((a, b) => a.prix - b.prix);
    } else if (sortBy === "priceDesc") {
      result.sort((a, b) => b.prix - a.prix);
    }

    return result;
  }, [filteredProducts, sortBy]);

  const totalPages = Math.ceil(
    filteredProducts.length / itemsPerPage
  );

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);

    window.scrollTo(0, 0);

    const searchParams = new URLSearchParams(
      window.location.search
    );

    searchParams.set("page", newPage.toString());

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;

    window.history.pushState({}, "", newUrl);
  };

  const currentCards = sortedProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return loading ? (
    <div className="loader"></div>
  ) : (
    <div>
      {/* ✅ Nouveau bouton premium */}
      <div className="filter-header">
        <Button
          id="sort-button"
          aria-controls={open ? "sort-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          variant="text"
          disableElevation
          onClick={handleClick}
          startIcon={<SortIcon />}
          endIcon={<KeyboardArrowDownIcon />}
          className="modern-sort-btn"
        >
          {sortBy === "priceAsc"
            ? "Prix croissant"
            : sortBy === "priceDesc"
            ? "Prix décroissant"
            : "Nouveautés"}
        </Button>

        <Menu
          id="sort-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => handleClose()}
          TransitionComponent={Fade}
          PaperProps={{
            elevation: 0,
            className: "modern-menu-paper",
          }}
        >
          <MenuItem
            onClick={() => handleClose("newest")}
            selected={sortBy === "newest"}
          >
            Nouveautés
          </MenuItem>

          <MenuItem
            onClick={() => handleClose("priceAsc")}
            selected={sortBy === "priceAsc"}
          >
            Prix croissant
          </MenuItem>

          <MenuItem
            onClick={() => handleClose("priceDesc")}
            selected={sortBy === "priceDesc"}
          >
            Prix décroissant
          </MenuItem>
        </Menu>
      </div>

      <div className="allProductsearch">
        {currentCards.map((produit, index) => (
          <ProductCard
            key={produit.article + index}
            categorie={produit.categorie}
            subcategorie={produit.subcategorie}
            subSubcategorie={produit.subSubcategorie}
            article={produit.article}
            prix={produit.prix}
            prixFlash={produit.prixFlash}
            prixPromo={produit.prixPromo}
            brand={produit.brand}
            famille={produit.famille}
            reference={produit.ref}
            stock={produit.stock}
            nouveau={produit.nouveau}
            livraisonGratuit={produit.livraisonGratuit}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <Pagination
            count={totalPages}
            page={currentPage}
            shape="rounded"
            variant="outlined"
            onChange={handlePageChange}
            color="warning"
            size="small"
          />
        </div>
      )}
    </div>
  );
}